import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_44: FaireProductEntity = {
  token: "legacy_prod_abbott-44",
  type: "product",
  name: 'Medium Flower Bloom Bowl Green 5" D',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/21fa642d0b650d3d3dcc64c191a310178d391910bbcd7ee537db3b80215be70c.jpeg",
  priceDollars: 24,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
